import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "italic-2hh5V",
  "use": "italic-2hh5V-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol stroke-linecap=\"round\" stroke-linejoin=\"round\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"italic-2hh5V\"><path d=\"M19 4h-9M14 20H5M15 4L9 20\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol